/* eslint-disable react/no-unknown-property */
import React from "react";
import { graphql, Script } from "gatsby";
import Layout from "@qlik/qlik/src/components/Layout";
import { searchTranslations } from "@qlik/qlik/src/translations/search";
import { getMicrocopyValueFromKeys, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
/**
 * GraphQL query to fetch header and footer data
 */
export const query = graphql`
    query($locale: String) {
        contentfulHeader: contentfulHeader(name: { eq: "Header" }, node_locale: { eq: $locale }) {
            ...Header
        }
        contentfulFooter(name: { eq: "Full footer" }, node_locale: { eq: $locale }) {
            ...Footer
        }
        contentfulThemeSettings(node_locale: { eq: $locale }) {
            ...ThemeSettings
        }
    }
`;

const searchClientURL = process.env.GATSBY_SEARCHUNIFY_URL;

/**
 * Search component
 * @param {Object} data - The data fetched from GraphQL query
 */
const Search = ({ data }) => {
    // get the translated text
    const searchMicrocopyData = data.contentfulThemeSettings?.searchPopupMicrocopyGroup;
    const [maintenanceText, maintenanceMode] = getMicrocopyValueFromKeys(searchMicrocopyData, [
        "search-popup.maintenance-text",
        "search-popup.maintenance-mode",
    ]);

    // create boolean isMaintenanceMode based on the value of maintenanceMode
    // if maintenanceMode is "On" or "True" (case-insensitive), isMaintenanceMode will be true
    // if maintenanceMode is not "On" or "True" (case-insensitive), or even undefined or null, isMaintenanceMode will be false
    const isMaintenanceMode = maintenanceMode?.toLowerCase() === "on" || maintenanceMode?.toLowerCase() === "true";

    return (
        <Layout
            headerData={data.contentfulHeader}
            footerData={data.contentfulFooter}
            searchPopupData={data.contentfulThemeSettings?.searchPopupMicrocopyGroup}
        >
            <Script src={`${searchClientURL}/main.js`} />

            <section className="py-10">
                {isMaintenanceMode ? (
                    maintenanceText && (
                        <div className="container">
                            <p
                                className="maintenance-text"
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(maintenanceText) }}
                            ></p>
                        </div>
                    )
                ) : (
                    <div className="container" su-container="" ng-app="searchUnifyApp" id="searchUnify">
                        <div className="row">
                            <su-app />
                        </div>
                    </div>
                )}
            </section>
        </Layout>
    );
};

export default Search;

/**
 * Head component for setting the title and and adding the stylesheet
 */
export const Head = ({ pageContext }) => {
    // get the translated text, and if it's not available, default to the english
    const translations = searchTranslations[pageContext.locale ?? "en"];
    const pageTitle = `${translations["pageTitle"]} | Qlik`;

    return (
        <>
            <title>{pageTitle}</title>
            <meta name="description" content={translations["metaDescription"]} />
            <link rel="stylesheet" href={`${searchClientURL}/main.css`} />
        </>
    );
};
